import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {version } from '../../../../package.json';

const useStyles = makeStyles((theme: Theme) => createStyles({
  text: {
    display: 'flex',
    fontSize: '0.8em',
    color: 'white'
  }
}));

export default () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Typography className={classes.text}>
        {t('Version')} {version}
      </Typography>
    </div>
  );
};
